import type AIResponse from "@/domain/entities/vistassistant/AIResponse";
import ConversationMarker, {
    type ThreadItem,
} from "@/domain/entities/vistassistant/ConversationMarker";
import type {
    ComponentData,
    RestoredConversationItem,
} from "@cs_teamwaydev/mailvista-sdk_react";
import userRequestMapper from "./userRequestMapper";

/**
 * A past conversation as the thread shows it: each turn its question and its answer (`toAnswer`),
 * each compaction its marker.
 */
const restoredConversationMapper = (
    items: RestoredConversationItem[],
    toAnswer: (response: ComponentData) => AIResponse,
): ThreadItem[] =>
    items.flatMap((item): ThreadItem[] =>
        item.kind === "compaction"
            ? [
                  new ConversationMarker({
                      at: new Date(item.at),
                      summary: item.summary,
                  }),
              ]
            : [userRequestMapper(item.question), toAnswer(item.response)],
    );

export default restoredConversationMapper;
